import CloudinaryImage from "@/components/cloudinary-image";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";
import { cn } from "@/lib/utils";

import CountersButtons from "../counters-buttons";
import type { UserType } from "../types";
import Counters from "./counters";
import Followers from "./followers";
import Profile from "./profile";

interface ProfileHeaderProps {
  className?: string;
  user: UserType;
}

export default function ProfileHeader({ className, user }: ProfileHeaderProps) {
  const isDesktop = useIsBreakPoint("md");

  return (
    <div
      className={cn(
        "mt-2.5 flex flex-wrap items-center justify-between md:mb-12.5 md:flex-nowrap md:justify-start",
        className
      )}
    >
      <div className="md:order-1">
        <CloudinaryImage
          className="size-30 rounded-full md:size-40"
          rW={320}
          size={isDesktop ? 160 : 120}
          user={user}
        />
      </div>
      {!user.isBlocked && (
        <div className="ml-4 flex flex-1 flex-col items-stretch gap-2 md:order-3 md:ml-10 md:w-82.5 md:flex-[0_0_auto]">
          <Counters facets={user.experiencesCountFacets || []} user={user} />
          <CountersButtons className="hidden md:grid" user={user} />
        </div>
      )}
      <div className="mt-2.5 flex w-full flex-col items-stretch gap-[15px] md:order-2 md:mt-0 md:ml-10 md:w-auto md:grow-1">
        <Profile user={user} />
        {!user.isBlocked && !!user.followers?.length && (
          <Followers
            followers={user.followers}
            followersCount={user.followersCount}
          />
        )}
      </div>
    </div>
  );
}
